const jiraQueryKeys = {
  components: [{ scope: 'jira', entity: 'components' }] as const,
  requestTypes: [{ scope: 'jira', entity: 'requestTypes' }] as const
}

export default jiraQueryKeys
